import { getConfigValue } from '../environment';

export const loadKount = (callback?: (sessionId: string) => void): void => {
  const addScriptTag = () => {
    const script = document.createElement('script');
    const KOUNT = getConfigValue('urls').kount;
    const KOUNT_MID = getConfigValue('kountMerchantId');
    script.src = `${KOUNT}/collect/sdk?m=${KOUNT_MID}`;
    script.id = 'kount';
    document.body.appendChild(script);
    script.onload = () => {
      if (callback && window.ka) {
        callback(window.ka.sessionId);
      }
    };
  };
  const scriptTag = document.querySelector('#kount');
  if (!scriptTag || !window.ka) {
    addScriptTag();
  } else {
    delete window.ka;
    scriptTag!.parentNode!.removeChild(scriptTag as Node);
    addScriptTag();
  }
};
